<div class="wvGauge d-flex flex-column pb-4" [ngClass]="hasBackdrop ? 'wvCustomItemDark' : 'wvCustomItemLight'" [hidden]="slideError" *ngIf="gaugeState !== null">
    <div>
        <div class="m-auto text-center" [ngStyle]="getStyles()">{{gaugeState?.GaugeTitle}}</div>
    </div>
    <div #gaugeContainer class="gauge-container lato-regular" style="flex:1 1 auto; height:90%"></div>
</div>

<div class="d-flex wvCustomItem wvSlideError" *ngIf="slideError">
    <div class="sadErrorBox">
        <div class="errorCharacter"></div>

        <div class="d-inline-block errorText">
            <div cvLocalizedText langSection="Wallboard_Display" langKey="Uh_Oh">Uh Oh</div>
            <div cvLocalizedText langSection="Wallboard_Display" langKey="Something_Went_Wrong">Something went wrong</div>
        </div>
    </div>
</div>
